export class XYSeriesData {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
}
XYSeriesData.X_INDEX = 0;
XYSeriesData.Y_INDEX = 1;
export class TerceraChartXYSeries {
    constructor() {
        this.data = [];
    }
    GetValue(index, level) {
        if (index >= this.Count() || index < 0) {
            return 0;
        }
        switch (level) {
            case XYSeriesData.X_INDEX:
                return this.data[index].x;
            case XYSeriesData.Y_INDEX:
                return this.data[index].y;
            default:
                return 0;
        }
    }
    Count() {
        return this.data.length;
    }
    Dispose() { }
}
export class TerceraChartAggregatedXYSeries {
    constructor() {
        this.data = [];
    }
    GetValue(index, level) {
        if (index >= this.Count() || index < 0) {
            return null;
        }
        return this.data[index];
    }
    Count() {
        return this.data.length;
    }
    Dispose() {
        for (let i = 0; i < this.data.length; i++) {
            this.data[i].Dispose();
        }
    }
}
